<template>
  <g
    id="Rear_Brake_light"
    v-on:click="changeSeverity('rightRearBreakLight')"
    :class="severityClass"
  >
    <path
      class="cls-379"
      d="M218.77,454.98v11.59h-4.76c-.1,0-.2-.02-.29-.05-.19-.06-.35-.18-.46-.34-.47-.67-1.28-2.3-1.28-5.4s.81-4.81,1.27-5.44c.12-.16,.28-.27,.47-.32,.08-.03,.17-.04,.26-.04h4.79Z"
    />
    <polygon
      class="cls-820"
      points="214.01 466.57 218.77 466.57 218.77 454.98 213.98 454.98 214.01 466.57"
    />
  </g>
</template>
<script>
export default {
  props: {
    severityClass: String
  },
  methods: {
    changeSeverity(section) {
      this.$emit('changeSeverity', section);
    }
  }
};
</script>
